import { toArray } from "../../lib/functions";
import { insertToArrayOnIndex } from "../../lib/helperFunctions";

const COLLAPSIBLE_FORM_CODES = ["billing"];

export function getSectionsWithFlatElementsFromSections(sections) {
  const isLastSectionIncludingLuggageOptions = getIsLastSectionIncludingLuggageOptions(
    sections
  );

  return insertToArrayOnIndex(
    sections.map((section) => ({
      ...section,
      elements: section.elements.map((element) => toArray(element)[0].name),
      collapsible: !!(
        section.code && COLLAPSIBLE_FORM_CODES.includes(section.code)
      ),
      isCollapsed: !!(
        section.code && COLLAPSIBLE_FORM_CODES.includes(section.code)
      ),
    })),
    sections.length - (isLastSectionIncludingLuggageOptions ? 0 : 1),
    { type: "PAYMENT" }
  );
}

function getIsLastSectionIncludingLuggageOptions(sections) {
  return sections[sections.length - 1]?.elements?.find((element) =>
    element?.name?.includes("Luggage")
  );
}
